import React, { PropTypes } from 'react';
import ProductItem from './ProductItem';

const NoItem = () => (
  <div className="ui message">
    Aucun produit. Veuillez en ajouter un via{' '}
    <a href="/products">l'utilitaire de gestion des données</a>
  </div>
);

const ProductList = ({ products, onToggle }) => {
  if (products.length) {
    return (
      <div className="ui segment">
        <table className="ui very basic table">
          <tbody>
            {products.map(product => (
              <ProductItem
                key={product.id}
                product={product}
                onToggle={onToggle}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return <NoItem />;
};

ProductList.propTypes = {
  products: PropTypes.array.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/products/ProductList.js